import React, { useContext } from "react";
import { RxCross2 } from "react-icons/rx";
import 'react-medium-image-zoom/dist/styles.css';

const Modal = ({ open, setOpen, img }) => {

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="relative">
        <button
          onClick={() => setOpen(false)}
          className="absolute top-2 right-2 p-1 bg-white rounded-full shadow hover:bg-gray-200 transition"
          aria-label="Close modal"
        >
          <RxCross2 className="w-6 h-6" />
        </button>

        <div className="flex">
          <img
            src={img}
            alt="Preview"
            className="max-w-full h-auto"
            style={{ maxHeight: "95vh" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Modal;